// The sentence a form shows in place of a record it could not put on screen.
//
// It lives beside `FormPage` rather than inside it so it can be exercised
// without mounting the page — the defect it exists to prevent is a wrong
// *sentence*, and the sentence is the only thing worth asserting.
import type { LoadFailureKind } from '../../app/api-client';

export const LOAD_ERROR_KEYS: Record<LoadFailureKind, string> = {
  // The only one that claims the record is not there. Reached from a 404 alone.
  not_found: 'form.error.not_found',
  forbidden: 'common.forbidden',
  // Everything else: the read did not come back, and that says nothing about
  // whether the record exists.
  load_failed: 'form.error.load_failed',
};
